module.exports = __webpack_public_path__ + "static/media/MichaelOberaigner.7f745cbe.jpg";